// -
import YouTubePlayer from 'youtube-player'

import { currentDevice } from '../../core/utils/currentDevice'
import { createBottomSheet } from '../../shared/bottom_sheet/bottom_sheet'
import Modal from '../../shared/modal/modal'

import { initializeUtagEvents } from './special_landing_header_analytics'

const modalId = 'special-landing-header-video-modal'
const contentVideo = '.video-special-landing'
let player

function initVideoYoutube(modal) {
  const idVideoYoutube = modal.querySelector('.js-video-youtube').dataset.videoYoutube
  const element = modal.querySelector('.js-video-youtube')

  player = YouTubePlayer(element, {
    videoId: idVideoYoutube,
    playerVars: {
      startSeconds: 0,
      rel: 0,
    },
  })

  player.playVideo()
}

function playVideo(container) {
  const video = container.querySelector(contentVideo)

  if (!video.classList.contains('js-video-youtube')) {
    video.play()
  } else {
    initVideoYoutube(container)
  }
}

function stopVideo(container) {
  const video = container.querySelector(contentVideo)
  if (!video.classList.contains('js-video-youtube')) {
    video.pause()
    video.currentTime = 0
  } else {
    player.destroy()
  }
}

let videoBottomSheet
function initVideoModal(modalId) {
  if (currentDevice.isMobile) {
    // --------------------------------------------------
    // VIDEO BOTTOM SHEET
    // --------------------------------------------------
    if (!videoBottomSheet) {
      videoBottomSheet = createBottomSheet({
        sheetId: modalId,
        sheetHeight: 100,
        onShow: bottomSheet => {
          playVideo(bottomSheet)
        },
        onClose: bottomSheet => {
          stopVideo(bottomSheet)
        },
      })
    }

    videoBottomSheet.show()
  } else {
    // --------------------------------------------------
    // VIDEO MODAL
    // --------------------------------------------------
    Modal.show(modalId, {
      onShow: modal => {
        ScrollLock.on()
        playVideo(modal)
      },
      onClose: modal => {
        stopVideo(modal)
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
      awaitOpenAnimation: true,
    })
  }
}
function init() {
  const block = document.querySelector('.js-special-landing-header')

  if (!block) return

  const triggerModalVideo = block.querySelector('.js-video-modal')

  if (!triggerModalVideo) return

  triggerModalVideo.addEventListener('click', () => {
    initVideoModal(modalId)
  })
}

init()

initializeUtagEvents()
